import { GameType } from "@onmo/graphql/graphql";
import { OnmoHtmlGame } from "../models/OnmoHtmlGame";

declare global {
  interface Window {
    ut: {
      _HTML: {
        canvasElement: HTMLCanvasElement | undefined;
      };
    };
  }
}

export type HtmlGameData =
  | {
      type: "moment";
      bundleURL: string;
      momentDatas?: string;
      seeds?: number | string;
    }
  | {
      type: GameType.DirectHtml;
      bundleURL: string;
      listMomentData: string;
      isFullGameMode: true;
      seeds?: number | string;
    }
  | {
      type: GameType.IframeHtml;
      url: string;
    };

export type HtmlGameCallbacks = {
  onHtmlGameLoaded: (controller: OnmoHtmlGame) => void;
  onScore: (controller: OnmoHtmlGame, score: number) => void;
  onEndGame: (controller: OnmoHtmlGame, score?: number) => void;
  onBundleLoadingProgress: (progress: number) => void;
  onClickRevive?: (message: ExternalGameMessage) => void;
};

export enum GameStateType {
  Loaded = "loaded",
  Playing = "playing",
  LevelUp = "levelup",
  AttemptOver = "attemptover",
  Replay = "replay",
  Over = "over",
}

export type HtmlGameMessage = {
  attemptNo: number;
  currlevel: number;
  gamestate: GameStateType;
  score: number;
};

export type ExternalGameMessage = {
  action: string;
  payload: {
    callback_func: string;
    type: string;
  };
  request: string;
};
